module.exports = __webpack_public_path__ + "img/8.7de5fd32.jpg";